export const services = [
  {
    title: "Giao hàng miễn phí",
    tagline: "Bán kính 2km đại học FPT",
    image: "images/service.png",
  },
  {
    title: "Ưu đãi bất ngờ",
    tagline: "Tiết kiệm đến 50%",
    image: "images/service-02.png",
  },
  {
    title: "Hỗ trợ 24/07",
    tagline: "Tư vấn với chuyên gia",
    image: "images/service-03.png",
  },
  {
    title: "Giá cả phải chăng",
    tagline: "Chỉ 50-80% thị trường",
    image: "images/service-04.png",
  },
  {
    title: "Bảo đảm thanh toán",
    tagline: "100% an toàn",
    image: "images/service-05.png",
  },
];
